module.exports = __webpack_public_path__ + "static/media/mission-2.ead0e1d0.png";